import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import React from "react";

Bugsnag.start({
  apiKey: "a714c7e3a2faebc8984d6947d51e2b71",
  plugins: [new BugsnagPluginReact()],
  releaseStage: process.env.RELEASE_STAGE || "development",
  autoTrackSessions: false,
  enabledReleaseStages: ["live", "staging"],
});

export const ErrorBoundary =
  Bugsnag.getPlugin("react").createErrorBoundary(React);
